import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import DeleteIcon from '@mui/icons-material/Delete'
import LogoutIcon from '@mui/icons-material/Logout'
const Barra = ((props) => {
    return (<>
        <div className="bg-gray-700 flex flex-row justify-between items-center">
            <label className="text-white text-lg ml-10">Editor de Eventos</label>
            {props.evento.id ? (<>
               <div className='text-lg text-gray-200 w-1/3 ml-20 flex flex-row justify-around'>
                   {props.evento.con_cod && <label onClick={e => props.setQueHacer('Codigo')}>Códigos </label>}
                   <label onClick={e => props.setQueHacer('Usuario')}>Usuarios </label>
                   <label onClick={e => props.setQueHacer('Inscrip')}>Inscripción </label>
                </div>
            </>)
            :''}
            <div className="flex flex-row justify-evenly mr-10">
                <AddCircleOutlineIcon 
                    fontSize='large' 
                    className="text-green-600 m-2"
                    onClick={() => props.setHacer('crear')}
                />
                <DeleteIcon fontSize='large' className="text-red-600 m-2" />
                <LogoutIcon 
                    fontSize='large' 
                    className="text-gray-300 m-2 ml-20 mr-10" 
                    onClick={e => props.setCual(false)}
                />
            </div>
            
        </div>
    </>)
})

export default Barra